module.exports = __webpack_public_path__ + "img/tuandui .d996838f.svg";